import { Transform } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsInt, IsOptional, Max, Min } from 'class-validator';
import {
  DEADLINE_MAX_WARNING_DAY,
  DEADLINE_MAX_WARNING_DAYS_COUNT,
  DEADLINE_MIN_WARNING_DAY,
} from './deadline.constants';
import { toWarningDaysArray } from './warning-days.transform';

/**
 * Preavvisi in giorni prima della scadenza, fino a 4. Base di
 * `UploadDocumentBodyDto`, `UpdateDocumentExpiryDto` (backend) e dei DTO
 * `Deadline`. Assente: il service usa `[expiryWarningDays ?? 7]`.
 */
export class DeadlineWarningDaysDto {
  @IsOptional()
  @Transform(({ value }) => toWarningDaysArray(value))
  @IsArray()
  @ArrayMaxSize(DEADLINE_MAX_WARNING_DAYS_COUNT)
  @IsInt({ each: true })
  @Min(DEADLINE_MIN_WARNING_DAY, { each: true })
  @Max(DEADLINE_MAX_WARNING_DAY, { each: true })
  warningDays?: number[];
}
